<template>
  <div style="" class="wxMyBalance">
    <van-nav-bar
        left-arrow
        title="奖励记录"
        @click-left="$router.go(-1)"
        left-text="">
    </van-nav-bar>

    <div style="padding-top: 50px">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <div
            v-for="item in list"
            :key="item.id">
          <div class="kyzCard">
            <div style="padding: 10px 20px 0px 20px">
              订单编号：<span style="color: black">{{ item.ordersn }}</span>
              <div style="margin-top: 5px">姓名：{{ item.nickName }}</div>
              <div style="margin-top: 5px">手机号：{{ item.mobile }}</div>
              <div style="margin-top: 5px">奖励：<span style="color:red">¥{{ item.amount }}</span></div>
              <div style="margin-top: 5px">时间：{{ item.createTime }}</div>
              <van-divider :dashed="true" :hairline="false" style="color:red"/>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import {
  NavBar,Divider,
  Button, Field,
  List, Card
} from 'vant'
import {postAction} from '@/api/manage'

export default {
  components: {
    [Button.name]: Button,
    [List.name]: List, [Divider.name]: Divider,
    [Field.name]: Field, [NavBar.name]: NavBar, [Card.name]: Card,
  },

  data() {
    return {
      active: 0,
      list: [],
      loading: false,
      finished: false,
      pageNumber: 1,
      balanceLast: 0,
      urls: 'balanceList',
      kyz: this,
      waitAmount: 0,
      totalBalance: 0,
      lastBalance: 0,
    }
  },
  mounted() {
    this.getBalance()
  },
  methods: {
    onLoad() {
      this.loadData()
    },
    getBalance() {
      const that = this
      //发送 post 请求
      postAction('/web/api/user/balanceAmount', {}).then(function (response) {
        console.log(response.result)
        that.totalBalance = response.result.totalBalance
        that.lastBalance = response.result.lastBalance
      }).finally(() => {
      })
    },
    loadData() {
      const that = this
      //发送 post 请求
      this.$nextTick(() => {
        postAction('/web/api/user/balanceList', {
          'pageNo': that.pageNumber,
        }).then(function (response) {
          console.log(response.result)
          // 异步更新数据
          for (let i = 0; i < 10; i++) {
            if (response.result.data.records[i]) {
              that.list.push(response.result.data.records[i])
            }
          }
          that.pageNumber = that.pageNumber + 1
          // 加载状态结束
          that.loading = false
          // 数据全部加载完成
          if (that.list.length >= response.result.data.total) {
            that.finished = true
          }
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.van-card__bottom {
  padding-bottom: 20px;
}

.van-card__desc {
  margin-top: 6px;
}

.van-card__title {
  font-size: 11pt;
}

.wxMyBalance .van-card__price {
  font-size: 13pt !important;
}

.wxMyBalance .van-card__price-integer {
  font-size: 13pt !important;
}

.van-nav-bar {
  position: fixed;
  width: 100%;
}

.balance_header {
  background-color: rgb(250, 90, 91);
  height: 130px
}

.balance_header .balance_amount {
  text-align: center;
  padding-top: 10px;
  font-size: 22pt;
  color: white
}

.balance_header .balance_zhan {
  text-align: center;
  padding-top: 0px;
  font-size: 11pt;
  color: white
}

.balance_tips {
  background-color: white;
  margin: -30px 20px 0px 20px;
  height: 60px;
  border-radius: 5px;
  text-align: center;
  line-height: 20px
}

.kyzCard .van-button__text {
  color: #07c160
}

.kyzCard {
  background-color: white;
  border-radius: 5px;
  color: #454545;
  font-size: 10pt;
}

.kyzCard .kyzCardAmount {
  color: red;
  font-size: 21px;
  padding-top: 6px
}

.topCount {
  font-size: 9pt;
  margin-top: 3px
}
</style>
